import { AbstractControl, ValidationErrors } from '@angular/forms';

export function NumberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || control.value.toString().match(/^\d+$/)) {
    return null;
  } else {
    return { invalidFormat: true };
  }
}
